"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityPermissionRequestClient = void 0;
const tslib_1 = require("tslib");
const qs_1 = tslib_1.__importDefault(require("qs"));
const authenticated_client_1 = require("./authenticated.client");
class EntityPermissionRequestClient extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super(...arguments);
        this.basePath = '/v1/entity-permissions/requests';
    }
    requestEntityPermission(projectId, entityType, entityId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.basePath}/projects/${projectId}/entities/${entityType}/${entityId}/users`;
            yield this.httpPost(url);
        });
    }
    getPendingRequests(projectId, entityType, entityId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.basePath}/projects/${projectId}/entities/${entityType}/${entityId}/users`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getPendingRequestCountByEntityIds(projectId, entityType, entityIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.basePath}/projects/${projectId}/entities/${entityType}/users/count`;
            const response = yield this.httpGet(url, {
                params: { ids: entityIds },
                paramsSerializer: (params) => qs_1.default.stringify(params, { arrayFormat: 'comma' }),
            });
            return response.payload;
        });
    }
    acceptPermissionRequest(projectId, entityType, entityId, userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.basePath}/projects/${projectId}/entities/${entityType}/${entityId}/users/${userId}`;
            yield this.httpPut(url);
        });
    }
    rejectPermissionRequest(projectId, entityType, entityId, userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.basePath}/projects/${projectId}/entities/${entityType}/${entityId}/users/${userId}`;
            yield this.httpDelete(url);
        });
    }
}
exports.EntityPermissionRequestClient = EntityPermissionRequestClient;
//# sourceMappingURL=entity-permissions-request.client.js.map